<template>
  <div>
    <novel-detail ref="novelDetail" :key="novelId" :novel-id="novelId" />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import NovelDetail from "@/components/organisms/NovelDetail.vue";

export default Vue.extend({
  // NOTE: metaタグの設定
  metaInfo: {
    meta: [
      {
        name: "robots",
        content: "none",
      },
    ],
  },
  props: { novelId: String },
  components: { NovelDetail },
  async beforeRouteLeave(to, from, next) {
    // beforeRouteLeave はルーティングされるページコンポーネント（このファイル）でのみ
    // vue-routerに認識されるため、子のNovelDetail（organism）側ではなくここに実装する。
    // デバウンス完了前（3秒以内）に画面遷移すると保存されずに変更が破棄されてしまうため、
    // 離脱前に未保存の変更があれば子コンポーネントの保存処理を確定させる
    const novelDetail = this.$refs.novelDetail as InstanceType<typeof NovelDetail> | undefined;
    if (novelDetail?.flushPendingChanges) {
      // 保存に失敗した場合、そのまま遷移すると未保存の変更が失われてしまうため遷移をキャンセルする
      // （エラー内容はGraphQLClient側の共通ダイアログで既に表示されている）
      const flushed = await novelDetail.flushPendingChanges();
      if (!flushed) {
        next(false);
        return;
      }
    }
    next();
  },
  async beforeRouteUpdate(to, from, next) {
    // サイドメニューから別の作品のdetailへ切り替えた場合はルート自体は変わらず
    // novelIdパラメータのみ変わるため、beforeRouteLeaveではなくこちらが呼ばれる。
    // 子のNovelDetailは:key="novelId"の変更で切替時に破棄・再生成されるため、
    // 破棄される前に未保存の変更があれば確定させる（理由はbeforeRouteLeaveと同様）
    const novelDetail = this.$refs.novelDetail as InstanceType<typeof NovelDetail> | undefined;
    if (novelDetail?.flushPendingChanges) {
      // 保存に失敗した場合、そのまま切替すると未保存の変更が失われてしまうため切替をキャンセルする
      const flushed = await novelDetail.flushPendingChanges();
      if (!flushed) {
        next(false);
        return;
      }
    }
    next();
  },
});
</script>
